import styled from 'styled-components'
import { Color } from 'root-constants'
import { TPageTitleProps } from './PageTitle'

export const StyledPageTitle = {
  PageTitle: styled.h1<TPageTitleProps>`
    font-weight: 700;
    font-size: 28px;
    line-height: 38px;
    text-align: center;
    color: ${Color.WHITE};
    margin-bottom: ${({ marginBottom }) => marginBottom && `${marginBottom}px`};
  `,
}
